var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTether = function SvgIconTether(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#86868B",
    fillRule: "evenodd",
    clipPath: "url(#IconTether_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.32 5.25c-.404.42-1.928.72-3.794.72s-3.421-.3-3.732-.72c.31-.33 1.493-.63 2.954-.69v.87c.25.03.529.03.809.03s.529-.03.808-.03v-.87c1.462.06 2.644.33 2.955.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.928 4.5 12.408.27a.6.6 0 0 0-.497-.27H3.245a.52.52 0 0 0-.467.27L.073 4.53a.576.576 0 0 0 .093.69l6.935 6.63c.218.21.59.21.809 0l6.935-6.66a.576.576 0 0 0 .093-.69zm-3.546 1.17c0 .42-1.306.81-3.047.87v2.04H6.686V6.6c-1.741-.09-3.047-.45-3.047-.87v-.9c0-.42 1.306-.81 3.047-.87v-.84H4.23v-1.2h6.561v1.17H8.335v.81c1.741.09 3.047.45 3.047.87z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconTether_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v12H0z"
  })))));
};
export default SvgIconTether;